/**
 * KingdomPreviewCard.jsx - Preview panel for kingdoms/city-states when viewing from distance
 */

import React from 'react';
import { KINGDOM_TYPES } from '../../../data/world-map/kingdoms';
import './KingdomPreviewCard.css';

export function KingdomPreviewCard({ kingdomId }) {
  const kingdomData = KINGDOM_TYPES[kingdomId];

  if (!kingdomData) {
    return null;
  }

  const isKingdom = kingdomData.type === 'kingdom';

  return (
    <div className="kp-card">
      <div className="kp-header">
        <div className="kp-icon" style={{ backgroundColor: kingdomData.color }}>
          {kingdomData.icon}
        </div>
        <div className="kp-title-area">
          <h3>{kingdomData.name}</h3>
          <div className="kp-type">
            {isKingdom ? '👑 Kingdom' : '🏛️ City-State'} • Tier {kingdomData.tier}
          </div>
        </div>
      </div>

      <div className="kp-flavor">
        {kingdomData.flavorText}
      </div>

      <div className="kp-hint">
        💡 Move to this tile to interact with {isKingdom ? 'the kingdom' : 'the city-state'}
      </div>
    </div>
  );
}

export default KingdomPreviewCard;
